import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HiLightningBolt, HiPlay, HiLocationMarker, HiClock } from 'react-icons/hi';
import Header from '../components/Header';
import './BrandOption2.css';

export default function BrandOption2({ config }) {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadGames();
  }, []);

  const loadGames = async () => {
    try {
      const res = await fetch(`${config.apiUrl}/games`);
      const data = await res.json();
      setGames(data.data.games || []);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const liveGames = games.filter(g => g.status === 'live');
  const upcomingGames = games.filter(g => g.status === 'scheduled' || g.status === 'ready');
  const recordedGames = games.filter(g => g.status === 'recorded' && g.recordingUrl);

  const logo = <HiLightningBolt className="header-logo-icon volt" />;

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="brand2">
      <Header logo={logo} brandName="VOLT LIVE" theme="dark" />
      
      <main className="main-content">
        <section className="hero-section volt-hero">
          <h1>ELECTRIFY YOUR GAME</h1>
          <p>High-voltage sports streaming</p>
        </section>

        {liveGames.length > 0 && (
          <section className="games-section">
            <h2>⚡ LIVE NOW</h2>
            <div className="games-grid">
              {liveGames.map(game => (
                <Link key={game.gameId} to={`/watch/${game.gameId}`} className="game-card volt-live">
                  <div className="card-badge volt-badge">LIVE</div>
                  <h3>{game.homeTeam} vs {game.awayTeam}</h3>
                  <div className="card-info">
                    <HiLocationMarker /> {game.venue}
                  </div>
                  <button className="watch-btn volt-btn">
                    <HiPlay /> WATCH
                  </button>
                </Link>
              ))}
            </div>
          </section>
        )}

        {upcomingGames.length > 0 && (
          <section className="games-section">
            <h2>UPCOMING</h2>
            <div className="games-grid">
              {upcomingGames.slice(0, 6).map(game => (
                <div key={game.gameId} className="game-card">
                  <h3>{game.homeTeam} vs {game.awayTeam}</h3>
                  <div className="card-info">
                    <HiLocationMarker /> {game.venue}
                  </div>
                  <div className="card-info">
                    <HiClock /> {new Date(game.scheduledStart).toLocaleString('en-US', { 
                      month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' 
                    })}
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {recordedGames.length > 0 && (
          <section className="games-section">
            <h2>⚡ REPLAYS</h2>
            <div className="games-grid">
              {recordedGames.slice(0, 6).map(game => (
                <Link key={game.gameId} to={`/watch/${game.gameId}`} className="game-card replay-card">
                  {game.thumbnailUrl && (
                    <div className="replay-thumbnail">
                      <img src={game.thumbnailUrl} alt="Match" />
                      <div className="thumbnail-overlay">
                        <HiPlay className="play-icon-large" />
                      </div>
                    </div>
                  )}
                  <div className="replay-content">
                    <div className="card-badge volt-badge">REPLAY</div>
                    <h3>{game.homeTeam} vs {game.awayTeam}</h3>
                    <div className="card-info">
                      <HiLocationMarker /> {game.venue}
                    </div>
                    <button className="watch-btn volt-btn">
                      <HiPlay /> WATCH
                    </button>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        )}
      </main>
    </div>
  );
}
